document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('.gold__button');
   const watchbutton = document.querySelector('.ghost__button');
  const target = document.querySelector('[data-section-target="courses"]');
  const preview = document.querySelector('[data-section-target="preview"]');

  if (button && target ) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
       history.pushState(null, '', '#courses');
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }

  if (watchbutton && preview) {
    watchbutton.addEventListener('click', function (e) {
      e.preventDefault();
       history.pushState(null, '', '#preview');
      preview.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }
});





document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll(
    '.desktopNav a, .mobileNav a'
  );

  if (!links.length) return;

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {

      const url = new URL(
        link.href,
        window.location.origin
      );

      const hash = url.hash;

      if (!hash) return;

      const targetName = decodeURIComponent(
        hash.substring(1)
      );

      console.log('Clicked hash:', hash);
      console.log('Target name:', targetName);

      // data-section-target="courses"
      const target = document.querySelector(
        '[data-section-target="' + targetName + '"]'
      );

      console.log('Target:', target);

      // Target nahi mila to normal link behavior
      if (!target) return;

      // Normal jump stop
      e.preventDefault();

      // URL mein #courses add/update
      history.pushState(
        null,
        '',
        hash
      );

      // Fixed header ki height
      const header = document.querySelector('.navBar');

      const headerHeight = header
        ? header.getBoundingClientRect().height
        : 0;

      // Target ki exact position
      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight;

      // Smooth scroll
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Mobile menu close
      const mobileNav = document.querySelector('.mobileNav');

      if (mobileNav) {
        mobileNav.hidden = true;
      }

    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const links = document.querySelectorAll(
    '.container a'
  );
  
  console.log("suite", links)
  if (!links.length) return;

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {

      const url = new URL(
        link.href,
        window.location.origin
      );

      const hash = url.hash;

      if (!hash) return;

      const targetName = decodeURIComponent(
        hash.substring(1)
      );

      console.log('Clicked hash:', hash);
      console.log('Target name:', targetName);


      const target = document.querySelector(
        '[data-section-target="' + CSS.escape(targetName) + '"]'
      );

      console.log('Target:', target);

      if (!target) return;


      e.preventDefault();
      history.pushState(
        null,
        '',
        hash
      );
      const header = document.querySelector('.navBar');

      const headerHeight = header
        ? header.getBoundingClientRect().height
        : 0;

      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      const mobileNav = document.querySelector('.mobileNav');

      if (mobileNav) {
        mobileNav.hidden = true;
      }
    });
  });
});
